export { default as UnitsMetricCmSolidIcon } from './UnitsMetricCmSolidIcon';
